import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "reading-list-callout"
}
const _hoisted_2 = { class: "reading-list-callout__text" }
const _hoisted_3 = { class: "reading-list-callout__covers" }
const _hoisted_4 = ["src"]

import { computed, ref } from 'vue'

import { storage } from '@/helpers/storage'

import AppButton from '@/app/components/button/AppButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ReadingListCallout16167',
  setup(__props) {

const isOpen = ref(true)

const covers = computed(() => {
  const covers = storage.getItem('sf_lq_books16167')
  if (!covers || !isOpen.value) {
    return null
  }

  return JSON.parse(covers) as string[]
})

function clearLibraryData(): void {
  isOpen.value = false
  storage.removeItem('sf_lq_books16167')
}

return (_ctx: any,_cache: any) => {
  return (covers.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "reading-list-callout__close",
          onClick: clearLibraryData
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "iconfont iclose" }, null, -1)
        ]))]),
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "reading-list-callout__title" }, " Check your first reading list in My Library ", -1)),
          _createVNode(AppButton, {
            tag: "router-link",
            to: { name: 'my_library.custom_lists' },
            class: "reading-list-callout__link",
            onClick: clearLibraryData
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" Open My Library ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(covers.value.slice(0, 5), (cover) => {
            return (_openBlock(), _createElementBlock("img", {
              key: cover,
              src: cover,
              width: "62",
              height: "83",
              alt: "",
              class: "reading-list-callout__cover"
            }, null, 8, _hoisted_4))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})